<template lang="html">
    <section>
        <div class="col-100 flex column nowrap justify-end animated fadeInLeft thank-you-page-header">
            <div class="container-text">
                <h2 class="title title-52">NEWSLETTER</h2>
            </div>
        </div>
        <div class="thank-you-page">
            <thank-you-send-form />
        </div>
    </section>
</template>

<script lang="js">
import thankYouSendForm from '@/components/parts/thank-you-send-form'

export default {
    name: 'thank-you-page',
    components: {
        'thank-you-send-form': thankYouSendForm
    },
}
</script>

<style>
.thank-you-page-header {
    background: rgba(5, 66, 121, .9);
    color: white;
    min-height: 25vh;
    padding-left: 20px;
}

.thank-you-page {
    padding: 10vh 0;
    background-color: #E5ECF0 !important;
}</style>


// WEBPACK FOOTER //
// src/components/views/thank-you-page.vue